module.exports = __webpack_public_path__ + "img/icon_dialog_wechat.7e3e53f9.png";